import { useState, useEffect } from "react";
import { collection, query, where, onSnapshot, Timestamp } from "firebase/firestore";
import { db } from "services/firebaseConfig";

export const useDuplicateChalesAlerts = (userRole) => {
  const [conflicts, setConflicts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Apenas admin ou editores devem ver esses alertas e processar essa query pesada
    if (userRole !== "admin" && userRole !== "editor") {
      setIsLoading(false);
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const q = query(
      collection(db, "reservations"),
      where("checkOutDate", ">=", Timestamp.fromDate(today))
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const activeReservations = [];
        snapshot.forEach((doc) => {
          const data = doc.data();
          if (data.checkInDate && data.checkOutDate && data.chaletNumber) {
            activeReservations.push({
              id: doc.id,
              chaletNumber: data.chaletNumber,
              checkInDate: data.checkInDate.toDate(),
              checkOutDate: data.checkOutDate.toDate(),
              guestInfo: data.guestInfo,
              phoneInfo: data.phoneInfo,
            });
          }
        });

        // Agrupar por chalé
        const byChalet = {};
        activeReservations.forEach((res) => {
          if (!byChalet[res.chaletNumber]) {
            byChalet[res.chaletNumber] = [];
          }
          byChalet[res.chaletNumber].push(res);
        });

        const detectedConflicts = [];

        // Para cada chalé, ordenar por check-in e verificar sobreposições
        Object.keys(byChalet).forEach((chaletNum) => {
          const reservations = byChalet[chaletNum].sort((a, b) => a.checkInDate - b.checkInDate);

          for (let i = 1; i < reservations.length; i++) {
            const prev = reservations[i - 1];
            const current = reservations[i];

            // Se o checkIn atual for MENOR que o checkOut anterior, há sobreposição!
            if (current.checkInDate < prev.checkOutDate) {
              detectedConflicts.push({
                chaletNumber: chaletNum,
                res1: prev,
                res2: current,
              });
            }
          }
        });

        setConflicts(detectedConflicts);
        setIsLoading(false);
      },
      (error) => {
        console.error("Erro ao buscar reservas para alerta de duplicidade:", error);
        setIsLoading(false);
      }
    );

    return () => unsubscribe();
  }, [userRole]);

  return { conflicts, isLoading };
};
